import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-password',
  templateUrl: './fh-svg-password.component.html',
  styleUrl: './fh-svg-password.component.scss'
})
export class FhSvgPasswordComponent {
  @Input() color: string = '';
}
